import type { SearchSchemaInput } from "@tanstack/react-router";

export type GridSearchParams = {
  page?: number;
  sort?: string;
  order?: "asc" | "desc";
  q?: string;
};

/**
 * Validates and coerces grid search params from the URL.
 * All fields are optional — hooks fill in defaults internally.
 *
 * Use directly as a route's `validateSearch`:
 *
 * ```tsx
 * export const Route = createFileRoute("/things/")({
 *   validateSearch: validateGridSearch,
 *   component: () => <ThingsPage />,
 * });
 * ```
 */
export function validateGridSearch(
  search: { page?: number; sort?: string; order?: string; q?: string; } & SearchSchemaInput,
): GridSearchParams {
  const result: GridSearchParams = {};
  const page = Number(search.page);
  if (page > 0) result.page = page;
  if (typeof search.sort === "string" && search.sort) result.sort = search.sort;
  if (search.order === "asc" || search.order === "desc") result.order = search.order;
  if (typeof search.q === "string" && search.q) result.q = search.q;
  return result;
}
